export default __webpack_public_path__ + "static/media/pc-squircle-1024-transparent.3baf528c.png";